/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {mapGetters} from 'vuex';

export default {
  name: 'error-storage-full',
  components: {},
  props: [],
  data () {
    return {
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data
      return
    },
  },
  mounted () {
    this.getSelfUserInfoFun
  },
  methods: {
    closePopupOfErrorSpaceFullFun(){
      bus.$emit('errorStorageFullStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
  },
  watch:{
    getSelfUserInfoFun(){
      return this.$store.getters.selfUserInfoGetters
    },
  }
}